import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';

function changebg() {
    document.body.style.backgroundColor = "#EDEDED";
    // toggleCaptchaBadge();

}
// const toggleCaptchaBadge = () => {
//     debugger;
//     const badge = document.getElementsByClassName('grecaptcha-badge')[0];
//     if (badge && badge instanceof HTMLElement) {
//         badge.style.visibility = 'hidden';
//     }
// };  

export class PaymentSuccess extends Component {
    // componentDidMount() {
    //     window.addEventListener('load', this.toggleCaptchaBadge);
    // } 

    componentDidMount() {
        debugger;
        $(document).ready(function() {
            $(".grecaptcha-badge").css("display", "none");
        });
       
    }
    render() {
        return (
            <>
                <div className="container-fluid" onLoad={changebg()}>
                    {/* yesil Alan*/}
                    <div className="row" style={{ padding: "3%" }}>
                        <div className="col-12">
                            {/* KUTU 1 */}
                            <div className="row no-gutters t-kutu t-yesilCizgi">
                                <div
                                    className="col bosluk backtop"
                                    style={{
                                        backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                                    }}
                                >
                                    {/* içerikler */}
                                    <div className="row no-gutters pb-4">
                                        <div className="col-12 d-flex justify-content-center pb-2">
                                            <i className="t-icon-bubble1 t-icGenelBaslikIconSuccess" />
                                        </div>
                                        <div className="col-12 d-flex justify-content-center pb-3 t-icGenelBaslikSuccess">
                                            TALEBİNİZ ALINMIŞTIR
                                        </div>
                                        <div className="col-12 text-center t-icYaziPayment">
                                            Talimatınızı talimatlarım menüsünden takip edebilirsiniz.


                                        </div>
                                    </div>
                                    {/* içerikler BİTTİ */}
                                </div>
                                <div className="col-auto renk" />
                            </div>
                            {/* KUTU 1 BİTTİ */}
                        </div>
                    </div>
                    {/* Duyurlar Baslık*/}
                    {/* duyrular Bitti*/}
                    {/* <div className="row" style={{ height: 30 }} /> */}
                </div>
            </>
        )
    }
}


const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSuccess);